import React, { FunctionComponent } from 'react';

// TODO: find solution for import svg as ReactComponent

interface Props {
  className?: string;
}

const Arrow: FunctionComponent<Props> = ({ className }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.70538 13.2948C6.31581 13.6843 6.31581 14.316 6.70538 14.7055C7.09466 15.0948 7.72569 15.0952 8.11538 14.7063L12 10.8302L15.8846 14.7063C16.2743 15.0952 16.9053 15.0948 17.2946 14.7055C17.6842 14.316 17.6842 13.6843 17.2946 13.2948L12.7071 8.70726C12.3166 8.31674 11.6834 8.31674 11.2929 8.70726L6.70538 13.2948Z"
      fill="white"
    />
  </svg>
);

export default Arrow;
